















































import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import filtersList from '@/components/Newsletters-stuff/filtersList.vue'
import activeTable from '@/components/Ui/ActiveTable/ActiveTable.vue'
import rcptTableConfig from '@/activeTables/Newsletters/recipients-stuff'
import Mailing from '@/models/mailing/mailing'
import {MAILING_STATUS_PROGRESS, MAILING_STATUS_COMPLETED} from '@/constants'
import Vue from 'vue'
import User from '@/models/Users/User'
export default Vue.extend({
  props: {
    scope: {} as () => {mailing: Mailing},
    options: {}
  },
  components: {
    infoRowsBlock,
    filtersList
  },
  data () {
    return {
      loaded: false,
      vissibleIdsList: false,
      vissibleFiltersList: false,
      vissibleAutoList: false,
      rcptTableConfig,
      interval: null,
      pageBaseUrl: `/newsletters-stuff/${this.$route.params.id}/info`
    }
  },
  computed: {
    status (): string {
      return this.scope.mailing.getStatus();
    },
    ts (): number {
      return this.scope.mailing.getTs();
    },
    serverTime (): number {
      return this.$store.state.serverTime;
    },
    isAutosent (): boolean {
      return this.scope.mailing.isAutosent()
    },
    user (): User | false {
      return this.$store.state.user.user
    }
  },
  methods: {
    async toggleList (): Promise<void> {
      if (!this.loaded) {
        if (this.$refs.rcptById && this.$refs.rcptByFilter) {
          // @ts-ignore
          let byId = await this.$refs.rcptById.loadList()
          // @ts-ignore
          let byFilter = await this.$refs.rcptByFilter.loadList()
          this.vissibleIdsList = !!byId.count;
          this.vissibleFiltersList = !!byFilter.count;
          this.vissibleAutoList = true;
          this.loaded = true;
        }
      } else {
        this.vissibleIdsList = false;
        this.vissibleFiltersList = false;
        this.loaded = false;
        this.vissibleAutoList = false;
      }
    },
    dataWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        let timeDiff = this.serverTime - this.ts;
        if (self.status === MAILING_STATUS_PROGRESS || self.status === MAILING_STATUS_COMPLETED && timeDiff < 7200000) {
          if (this.user) {
            // @ts-ignore
            self.reloadData();
          }
        }
      }, 2000)
    },
    async reloadData (): Promise<void> {
      // @ts-ignore
      await this.$refs.rcptById.loadList()
      // @ts-ignore
      await this.$refs.rcptByFilter.loadList()
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    }
  },
  async mounted () {
    setTimeout(() => {
      this.toggleList();
    }, 200);
    this.dataWatcher();
    this.$root.$on('relogin', this.clearInterval)
  },
  beforeDestroy () {
    this.clearInterval()
    this.$root.$off('relogin', this.clearInterval)
  },
  watch: {
    status (newVal, oldVal) {
      /* if (newVal !== oldVal && newVal === MAILING_STATUS_COMPLETED) {
        this.reloadData();
      } */
    }
  }
})
